import { render, staticRenderFns } from "./HeadlineItem.vue?vue&type=template&id=6c7e2cbc&scoped=true&"
import script from "./HeadlineItem.vue?vue&type=script&lang=js&"
export * from "./HeadlineItem.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineItem.vue?vue&type=style&index=0&id=6c7e2cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e2cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VDivider,VImg,VListItem,VListItemContent,VListItemTitle})
